import {
  SET_INTERFACE,
  INCREMENT_REQUEST_NUMBER,
  SET_METRICS,
  SET_AUDIENCE_SIZE,
  SET_HISTORICAL_VIEWERSHIP,
  SET_UNIVERSE,
  REMOVE_FROM_SELECTED_DAY_PART_NETWORKS,
  SET_DAY_PART_NETWORKS,
  SET_SELECTED_VIEWERSHIP_NETWORKS,
  REMOVE_ALL_DAY_PART_NETWORKS,
  SET_LOADING,
  SET_VIEWING_STREAM,
  RESET,
} from './actions'

import { LAS_DEFAULT_STATE } from './index'

const mutations = {
  [SET_INTERFACE]: (state, inter) => {
    state.interface = inter
  },
  [INCREMENT_REQUEST_NUMBER]: (state) => {
    state.requestNumber = state.requestNumber + 1
  },
  [SET_METRICS]: (state, metrics) => {
    state.metrics = metrics
  },
  [SET_AUDIENCE_SIZE]: (state, audienceSize) => {
    state.audienceSize = audienceSize
  },
  [SET_HISTORICAL_VIEWERSHIP]: (state, historicalViewership) => {
    state.hisoricalViewership = historicalViewership
  },
  [SET_UNIVERSE]: (state, universe) => {
    state.universe = universe
  },
  [SET_DAY_PART_NETWORKS]: (state, networks) => {
    state.selectedDayPartNetworks = networks
  },
  [SET_SELECTED_VIEWERSHIP_NETWORKS]: (state, networks) => {
    state.selectedViewershipNetworks = networks
  },
  [REMOVE_FROM_SELECTED_DAY_PART_NETWORKS]: (state, network) => {
    let indexToRemove = state.selectedDayPartNetworks.findIndex((n) => n === network)
    if (indexToRemove >= 0) {
      state.selectedDayPartNetworks.splice(indexToRemove, 1)
      state.selectedDayPartNetworks = [...state.selectedDayPartNetworks]
    }
  },
  [REMOVE_ALL_DAY_PART_NETWORKS]: (state) => {
    state.selectedDayPartNetworks = []
  },
  [SET_LOADING]: (state, v) => {
    state.loading = v
  },
  [SET_VIEWING_STREAM]: (state, v) => {
    state.viewingSource = v
  },
  [RESET]: (state) => {
    for (let key of Object.keys(LAS_DEFAULT_STATE)) {
      state[key] = LAS_DEFAULT_STATE[key]
    }
  },
}
export default mutations



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/LAS/store/mutations.js